import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-section-light pt-24 pb-16 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-[#1e3a5f] font-medium mb-8 hover:opacity-70 transition-opacity">
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </Link>

        <h1 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-2 tracking-tight">Privacy Policy</h1>
        <p className="text-[#5a5a5a] text-sm mb-8">Last updated: February 2025</p>

        <div className="space-y-6 text-[#3d3d3d] text-[15px] leading-relaxed">
          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">What we collect</h2>
            <p>We collect basic contact information (name, email, message) only when you submit our contact form or email us directly.</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">How we use it</h2>
            <p>Your information is used solely to respond to your enquiry. Nothing else.</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">What we don't do</h2>
            <p>We do not sell, share, or market your data. No tracking, no profiling, no marketing lists.</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] mb-2">Your rights</h2>
            <p>You can request deletion of your data at any time by emailing <a href="mailto:hello@crestfieldservices.co.uk" className="text-[#1e3a5f] font-medium hover:underline">hello@crestfieldservices.co.uk</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
